
  import { PremiumServiceEventTypeEnum, PremiumServiceEventTypes, PremiumServiceProductTypeEnum, PremiumServiceRequestTypeEnum } from "@/enums/PremiumServiceEventTypes";
  import moment from "moment";
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        eventTypes: Object.values(PremiumServiceEventTypeEnum),
        requestTypes: Object.values(PremiumServiceRequestTypeEnum),
        productTypes: Object.values(PremiumServiceProductTypeEnum),
        date: {
          start: moment()
            .subtract(1, "week")
            .toISOString()
            .substring(0, 10),
          end: moment()
            .toISOString()
            .substring(0, 10)
        },
        picker: {
          start: false,
          end: false
        },
        loading: true,
        period: "week",
        periods: [
          { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Week"], value: "week" },
          { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Month"], value: "month" },
          { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Year"], value: "year" }
        ],
        headers: [
          {
            text: "Type",
            value: "serviceItemType"
          },
          {
            text: "Service Requests",
            align: "start",
            value: "requests.length"
          },
          { text: "Booked / Ordered by Family", value: "bookedByFamily" },
          { text: "Booked / Ordered by Resident", value: "bookedByResident" }
        ],
        jsonFields: {
          "Type": "serviceItemType",
          "Service Requests": "requests.length",
          "Booked / Ordered by Family": {
            field: "requests",
            callback: value =>
              value.filter(request => request.bookByFamilyId).length
          },
          "Booked / Ordered by Resident": {
            field: "requests",
            callback: value =>
              value.filter(request => !request.bookByFamilyId).length
          }
        }
      };
    },
    async mounted() {
      await this.$store.dispatch("getAdditionalServices");
      await this.$store.dispatch(
        "getAdditionalServiceRequestsByDates",
        this.date
      );
      this.loading = false;
    },
    computed: {
      ...mapState({
        facility: state => (state as any).facilityModule.selectedFacility,
        services: state => (state as any).additionalServicesModule.additionalServices,
      }),
      requests() {
      return this.$store.state.additionalServicesModule.serviceRequests.map((s: any) => {

        const service = s

        if (this.eventTypes.includes(s.serviceItemType)) {
          service.serviceItemType = PremiumServiceEventTypes.Event
        }
        else if (this.requestTypes.includes(s.serviceItemType)) {
          service.serviceItemType = PremiumServiceEventTypes.Request
        }
        else if (this.productTypes.includes(s.serviceItemType)) {
          service.serviceItemType = PremiumServiceEventTypes.Product
        }
        else{
          service.serviceItemType = 'Undefined'
        }

        return service
      })

    },
      formattedStartDate() {
        return moment(this.date.start).format(this.facility.dateFormat)
      },
      formattedEndDate() {
        return moment(this.date.end).format(this.facility.dateFormat)
      },
      formattedSelectedDateRange() {
        return `${moment(this.date.start).format(this.facility.dateFormat)} - ${moment(this.date.end).format(this.facility.dateFormat)} `;
      },
      requestsByType() {
      const requestsByKeys = this.requests.reduce((accum, current) => {
        const serviceItemType = current.serviceItemType;

        if(serviceItemType?.length){
          if (!accum[serviceItemType]) {
            accum[serviceItemType] = { serviceItemType, requests: [] };
          }
          else{
            accum[serviceItemType].requests.push(current);
          }
        }

        return accum;
      }, {});

      const resultArray = Object.values(requestsByKeys);

      return resultArray
    }
    },
    methods: {
      handleChangePeriod(period) {
        this.date.start = moment()
          .subtract(1, period)
          .toISOString()
          .substring(0, 10);
        this.date.end = moment()
          .toISOString()
          .substring(0, 10);

        this.submit();
      },
      async submit() {
        this.loading = true;
        await this.$store.dispatch(
          "getAdditionalServiceRequestsByDates",
          this.date
        );
        this.loading = false;
      }
    }
  };
